// ExistingLoansPage.jsx
import React from "react";
import { Breadcrumbs, Grid, Link, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Loader from "../../../src/components/Loader/Loader";
//style
import "./creditScoreRes.css";

import { useLocation, useNavigate } from "react-router-dom";

//Images
import CRIF from "./images/CRIF.svg";
import TransUnion from "./images/TransUnion.svg";
import experian from "./images/experian.svg";
import Equifax from "./images/Equifax.svg";
import RoopyaLogo from "../../assets/images/logo-blue.png";

//micro component

import CreditScoreArcRes from "../BuroRecords/creditScoreArcRes";
import newStyleCred from "./ScoreDetailsPage.style";
import { useCookies } from "react-cookie";
import { getCookie } from "../../utils/common";
import * as urls from "../../urls"; ///utils/urls
import axios from "axios";
import { useState, useEffect, useContext } from "react";
import ScoreCard from "./scoreCard";
import OfferCard from '../BuroRecords/offerCard';

import CustomerContext from "../../context/CustomerContext";

const CreditScoreRes = (props) => {
  const navigate = useNavigate();
  let domain = window.location.host.split(".")[0];
  if (window.location.host.includes("localhost")) {
    domain = "yoindi";
  }
  const [score, setScore] = useState("");
  const score1 = 500;
  // * Context to store customer details
  const { customerDetails } = useContext(CustomerContext);
  // * Cookies
  const [cookies, setCookie] = useCookies(["user"]);
  const contact_id = getCookie("contactID");
  const lead_id = getCookie("leadID");
  const fullNameFromCookies = getCookie("fullName");

  
  
  const access_token = getCookie("tokenForCustomers");
  const activeSlide = getCookie("lastSlide");
  const location = useLocation();

  const newCreditStyle = newStyleCred();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentPercentage, setPaymentPercentage] = useState(0);
  const [cardUtilizationPer, setCardUtilizationPer] = useState(0);
  const [paymentHistoryArr, setPaymentHistoryArr] = useState([]);
  const [totalAge, setTotalAge] = useState("");
  const [totalOverdueAmt, setTotalOverdueAmt] = useState(false);
  const [creditScore, setCreditScore] = useState(null);
  const [fullNameFromCrif, setFullNameFromCrif] = useState("");
  console.log({fullNameFromCrif, fullNameFromCookies, fullName: decodeURIComponent(fullNameFromCookies)})

  // const Full_Name = decodeURIComponent(fullName);
  const decodedFullNameFromCookies = decodeURIComponent(fullNameFromCookies).split(' ')[0];
  const nameParts2 = fullNameFromCookies.split(' ');
  const Full_Name = nameParts2[0];

  // const Full_Names_Crif = decodeURIComponent(fullNames);
  const nameParts1 = fullNameFromCrif.split(' ');
  const Full_Names_Crif = nameParts1[0];
  

  const [buroScoreP, setBuroScoreP] = useState(null);


  const [arrListNew, setArrList] = useState([]);
  const [duplicateList, setDuplicateList] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState("");
  const [preApprovalData, setPreApprovalData] = useState([]);
  console.log("preApprovalData:",preApprovalData)
 


  const viewReport = () => {
    navigate("/customers/home/dashboard/report-details");
  };

  const headersCommonNews = {
    domain_name: domain,

    Authorization: `Bearer ${access_token || ""}`,
    "Content-Type": "application/json",
  };

  let bodyData = {
    contact_id: contact_id,
    // props?.location?.state?.id
  };

  let body_Data = {
    // lead_id : 55301
    lead_id : lead_id
  }

  function monthDiff(dateFrom, dateTo) {
    return (
      dateTo.getMonth() -
      dateFrom.getMonth() +
      12 * (dateTo.getFullYear() - dateFrom.getFullYear())
    );
  }

  function diff_year_month_day(dt1, dt2) {
    var time = (dt2.getTime() - dt1.getTime()) / 1000;
    var year = Math.abs(Math.round(time / (60 * 60 * 24) / 365.25));
    var month = Math.abs(Math.round(time / (60 * 60 * 24 * 7 * 4)));
    // var days = Math.abs(Math.round(time / (3600 * 24)));
    let totMonth = year * 12;
    let reqMonth = 0;
    if (totMonth < month) {
      reqMonth = month - totMonth;
    }
    if (year || reqMonth) {
      return year + "y " + reqMonth + "m";
    } else {
      return 0;
    }
  }

  function daysDiff(dt1, dt2) {
    // calculate the time difference of two dates JavaScript
    var diffTime = dt2.getTime() - dt1.getTime();

    // calculate the number of days between two dates javascript
    var daysDiff = diffTime / (1000 * 3600 * 24);

    return daysDiff;
  }

  function startLoader() {
    // Start your loader or loading operation here

    // Set a timeout for 5000 milliseconds (5 seconds)
    loaderTimeout = setTimeout(function() {
        // Timeout function, handle the timeout scenario here
        
        // Stop or handle the loader as needed
    }, 5000);
}

  useEffect(() => {
    setIsLoading();
    var config7 = {
      method: "post",
      url: `${process.env.REACT_APP_API_BASE_URL}${urls.CREDIT_DETAILS_DB}`,
      headers: headersCommonNews,
      data: bodyData,
    };
    axios(config7)
      .then(function (response) {
        
        setIsLoading(false);
        
        setCreditScore(
          response?.data?.data?.crfi_data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.[
            "SCORE-VALUE"
          ]
        );

        setFullNameFromCrif(
          response?.data?.data?.crfi_data?.["B2C-REPORT"]?.REQUEST?.["NAME"]
        );
        let list = response?.data?.data?.crfi_data?.["B2C-REPORT"];

        let arrList = [];
        let totalpaymentMonthCount = 0;
        let allTotalMonths = 0;
        // console.log("allTotalMonths", allTotalMonths);
        let totalBalance = 0;
        let totalCredit = 0;
        let totalOverdueAmount = 0;
        let disburseDate = [];
        let historyArr = [];
        // console.log("inside list=>", list);
        let arrAc = [];
        let arrCl = [];
        // console.log("if1234", list?.RESPONSES);
        list?.RESPONSES?.map((d) => {
          // console.log("if12345", d?.RESPONSE);
          if (d?.RESPONSE?.["LOAN-DETAILS"]?.["ACCOUNT-STATUS"] === "Active") {
            arrAc.push(d);
            // console.log("if");
          } else {
            arrCl.push(d);
            // console.log("else");
          }
        });
        let newlist = [...arrAc, ...arrCl];
        // console.log("newList=>", newlist);
        newlist.map((data) => {
          let loanDetails = data?.RESPONSE?.["LOAN-DETAILS"];
          // console.log("loanDetails", loanDetails);
          // console.log("inside list=>", data);
          // if (loanDetails?.["ACCT-TYPE"] === "Credit Card") {
          let dateString = loanDetails?.["DISBURSED-DT"];
          let [day, month, year] = dateString.split("-");
          const dateObj = new Date(+year, +month - 1, +day);
          disburseDate.push(dateObj);

          // if (loanDetails?.["ACCOUNT-STATUS"] === "Active") {
          let months = monthDiff(dateObj, new Date());
          // } else {
          //   months = monthDiff(dateObj, d);
          // }
          // console.log("dateCheck=>", months);
          var years = loanDetails?.["DISBURSED-DT"]
            ? new Date(
                new Date() - new Date(loanDetails?.["DISBURSED-DT"])
              ).getFullYear() - 1970
            : 0;
          let ageAcount = diff_year_month_day(new Date(), dateObj);
          let dateLast = loanDetails?.["LAST-PAYMENT-DATE"]
            ? loanDetails?.["LAST-PAYMENT-DATE"]
            : "";
          let days = "";
          if (dateLast) {
            let [dayl, monthl, yearl] = dateLast?.split("-");
            const dateObjLast = new Date(+yearl, +monthl - 1, +dayl);
            let daysLastPay = loanDetails?.["LAST-PAYMENT-DATE"]
              ? daysDiff(dateObjLast, new Date())
              : 0;
            days = daysLastPay;
          }
          // console.log("Days=>", days);
          let newArray = loanDetails?.["COMBINED-PAYMENT-HISTORY"]
            .split(",")
            .map((data, index) => {
              if (index === 0) {
                return data;
              }
              if (
                index !==
                loanDetails?.["COMBINED-PAYMENT-HISTORY"].length - 1
              ) {
                return data.split("|")[1];
              }
            });
          let fullPaymentMonthCount = 0;
          let lateDaysCountArr = loanDetails?.["COMBINED-PAYMENT-HISTORY"]
            .split("|")
            .map((data) => {
              // console.log("data=>", newArray);

              if (data.split(",")[1]) {
                let obj = {};
                if (!parseInt(data.split(",")[1].slice(0, 3))) {
                  fullPaymentMonthCount = fullPaymentMonthCount + 1;
                  allTotalMonths = allTotalMonths + 1;
                  obj = {
                    data: "",
                    month: data.split(",")[0].split(":")[0],
                    year: data.split(",")[0].split(":")[1],
                  };
                } else {
                  obj = {
                    data: parseInt(data.split(",")[1].slice(0, 3)),
                    month: data.split(",")[0].split(":")[0],
                    year: data.split(",")[0].split(":")[1],
                  };
                }
                return obj;
              }
            });

          // let countArr = [];

          let reqArrya = [];
          newArray.map((data) => {
            if (data) {
              let obj = {
                mon: data.split(":")[0],
                year: data.split(":")[1],
              };
              reqArrya.push(obj);
            }
          });
          const groupByCategory = reqArrya.reduce((group, product) => {
            const { year } = product;
            group[year] = group[year] ?? [];
            group[year].push(product.mon);
            return group;
          }, {});
          let missed = days < 30 ? 0 : days / 30 > 6 ? 6 : days / 30;
          let missedInLast6Month = Math.floor(missed);
          let NewdateLast = loanDetails?.["LAST-PAYMENT-DATE"]
            ? loanDetails?.["LAST-PAYMENT-DATE"]
            : "";
          let latestDate = "";
          if (NewdateLast) {
            let [day1, monthl, yearl] = NewdateLast?.split("-");
            let newDate = new Date(+yearl, +monthl - 1, +day1);
            let d = newDate.getDate();

            const m = newDate.toLocaleString("default", { month: "short" });
            let y = newDate.getFullYear();
            let dateN = d + " " + m + ", " + y;

            latestDate = dateN;
          }
          let disDate = loanDetails?.["DISBURSED-DT"]
            ? loanDetails?.["DISBURSED-DT"]
            : "";
          let lastDisDate = "";
          if (disDate) {
            let [day1, monthl, yearl] = disDate?.split("-");
            let newDate = new Date(+yearl, +monthl - 1, +day1);
            let d = newDate.getDate();

            const m = newDate.toLocaleString("default", { month: "short" });
            let y = newDate.getFullYear();
            let dateN = d + " " + m + ", " + y;

            lastDisDate = dateN;
          }
          // console.log("newArray=>", lateDaysCountArr, groupByCategory);
          let obj = {
            limit: loanDetails?.["CREDIT-LIMIT"],
            status: loanDetails?.["ACCOUNT-STATUS"],
            lastUpdated: latestDate,

            lenderName: loanDetails?.["CREDIT-GUARANTOR"],
            lastPayDay: days,
            last6month: missedInLast6Month,
            reportingDate:
              newArray[0].split(":")[0] + " ," + newArray[0].split(":")[1],
            disbursedAmt: loanDetails?.["DISBURSED-AMT"],
            disbursedDate: lastDisDate,
            accountNumber: loanDetails?.["ACCT-NUMBER"],
            outstanding: loanDetails?.["CURRENT-BAL"],
            accountType: loanDetails?.["ACCT-TYPE"],
            paymentHistory: loanDetails?.["COMBINED-PAYMENT-HISTORY"],
            paymentMonthCount: loanDetails?.[
              "COMBINED-PAYMENT-HISTORY"
            ]?.replace(/[^|]/g, "").length,
            totalMonths: fullPaymentMonthCount,
            currentBalance: loanDetails?.["CURRENT-BAL"],
            ageAccount: ageAcount,
            historyArray: loanDetails?.["COMBINED-PAYMENT-HISTORY"].split(","),
            paymentHistoryDate: groupByCategory,
            duesDaysCountArray: lateDaysCountArr,
          };
          let limitNew = loanDetails?.["CREDIT-LIMIT"];
          console.log("limitNew", loanDetails)
            ? parseInt(loanDetails?.["CREDIT-LIMIT"].replace(/,/g, ""))
            : 0;
          // console.log("lomitNew=>", limitNew, loanDetails?.["CREDIT-LIMIT"]);
          totalBalance =
            totalBalance +
            parseInt(loanDetails?.["CURRENT-BAL"].replace(/,/g, ""));
          if (loanDetails?.["OVERDUE-AMT"]) {
            totalOverdueAmount =
              totalOverdueAmount +
              parseInt(loanDetails?.["OVERDUE-AMT"].replace(/,/g, ""));
            // console.log("totalOverdueAmount", totalOverdueAmount);
          }
          totalCredit = totalCredit + limitNew;
          // console.log("limitNew", limitNew);
          totalpaymentMonthCount =
            totalpaymentMonthCount +
            loanDetails?.["COMBINED-PAYMENT-HISTORY"]?.replace(/[^|]/g, "")
              .length;

          // console.log("newArr=>", groupByCategory, obj);
          historyArr.push(groupByCategory);
          arrList.push(obj);
          // }
        });
        const minDate = new Date(Math.min.apply(null, disburseDate));
        let totalAgeCount = diff_year_month_day(new Date(), minDate);
        setTotalAge(totalAgeCount);
        // console.log("totalAgeCount", totalAgeCount);
        // console.log("historyArr=>", historyArr);
        setPaymentHistoryArr(historyArr);
        let paymentPercentage = (allTotalMonths / totalpaymentMonthCount) * 100;
        // console.log(
        //   "TotalBal=>",
        //   allTotalMonths,
        //   paymentPercentage,
        //   totalBalance,
        //   totalCredit,
        //   totalBalance / totalCredit
        // );
        let cardUtilizationPer = (totalBalance / totalCredit) * 100;
        // console.log(
        //   "data Uti=>",
        //   totalBalance,
        //   totalCredit,
        //   cardUtilizationPer
        // );
        setPaymentPercentage(paymentPercentage);
        setCardUtilizationPer(cardUtilizationPer);
        setTotalOverdueAmt(
          Intl.NumberFormat("en-IN").format(totalOverdueAmount)
        );
        // console.log();
        // console.log("ReqList=>", totalOverdueAmount);
        setArrList(arrList);
        setDuplicateList(arrList);
      })
      .catch((error) => {});
  }, []);

  ////pre-approval Api////
  useEffect(() => {
    setIsLoading();
    var config7 = {
      method: "post",
      url: `${process.env.REACT_APP_API_BASE_URL}${urls.Pre_Approval}`,
      headers: headersCommonNews,
      data: body_Data,
    };
    axios(config7)
      .then(function (response) {
        setIsLoading(false);
        response?.data
        // console.log("response12345:",response?.data?.data)
        let offerList = response?.data?.data;
        // console.log("OfferList:",offerList)
        let newList = [];

        offerList?.map((d) => {
          // console.log("12345",d?.["log_status"])
          if (d?.["log_status"] === "Approved"){newList.push(d)}
        });
        setPreApprovalData(newList)
        // console.log("Approved",newList);
      })
      .catch((error) => {});
  }, []);

  ////

 
  return (
    <div>
      {isLoading ? (
              <Box sx={{ display: 'flex',justifyContent: "space-around", }}>
              <CircularProgress />
            </Box>
            ) : 
      <div>
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/customers/home/dashboard">HOME</Link>
          <Link to="/customers/home/dashboard" onclick="return false;">CIBIL</Link>
        </Breadcrumbs>
        <div className="headerclass">
          <span className="textNormal padTop">Your Credit Score</span>
          <span className="textNormal marbottom">
            Hi, {fullNameFromCookies !== "" ? decodedFullNameFromCookies : Full_Names_Crif}
            
          </span>
        </div>
        <div className="scoreComp">
          <div className="tabContainer">
            <div className="scorecompitem bordercolor crifBor" checked>
              <img src={CRIF} alt="" className="imgstyCRIF crif" />
            </div>

            <div className="scorecompitem">
              <img
                src={RoopyaLogo}
                alt=""
                style={{ width: "80px", padding: "6px" }}
                className="imgsty"
              />
            </div>

            <div className="scorecompitem">
              <img src={TransUnion} alt="" className="imgsty" />
            </div>

            <div className="scorecompitem">
              <img src={experian} alt="" className="imgsty" />
            </div>

            <div className="scorecompitem borderBott">
              <img
                src={Equifax}
                alt=""
                style={{ opacity: "0.3", margin: "auto", padding: "10px" }}
              />
            </div>
          </div>
          {/* <div> */}
          {/* <div>Credit score for</div><div>Next report on</div> */}
          <div className="div-parent">
            <div className="score-div">
              <CreditScoreArcRes
                creditScore={creditScore}
                ContactId={contact_id}
                setBuroScoreP = {setBuroScoreP}
              />
            </div>
          </div>
          <div className="parenthed">
            {/* <div className="childhed">
              <span className="headerTextsty">Your score needs attention!</span>
              <br/>
              <span className="normalText">Your credit history is bad. But don't worry, with the right guidance and discipline, you can improve your credit score. First, do not miss any payment of your credit card bills or loan EMIs. Also, do not apply for any new loan or credit card until your score improves.</span>
            </div> */}
            
            <div className={`buttonsty buttonsty_text ${!(creditScore || buroScoreP) && `detailsButtonActive`}`} onClick={viewReport} >
              View Report Details
            </div>
          </div>
        </div>

        {/* </div> */}

        {/* new ui for pre approved */}
        <div style={{display: "flex",
    flexDirection: "row",
    width: "100%",
    overflow: "auto",
    /* padding-bottom: 15px; */
    flexWrap: "nowrap",
    padding: "5px",
     
    // borderSpacing: "2px"
    }}>
        {/* <Grid container spacing={2} 
        style={{padding: 5, paddingTop: 20}} 
          className="card-container"
        > */}
        {/* <Grid item xs={12} sm={6} md={4} lg={4}> */}
        
          {isLoading ? (
              <Loader />
            ) : preApprovalData.length > 0 ? (
              preApprovalData.map((data, index) => {
                return <OfferCard key={index} data={data} />;
              })
            ) : (
              <h1 style={{ fontWeight: 500, color: "gray", fontSize: "20px", display: "flex" , flexDirection: "column", textAlign: "center" , width: "100%", paddingTop:"8px"}}>
                You don't have any type of Pre-Approved Loan
              </h1>
            )}
        {/* </Grid> */}
        
    {/* </Grid> */}
        {/* new ui for pre approved */}
        </div>

      </div>

}
    </div>
  );
};

export default CreditScoreRes;
